let homeSwiper;

const resizeThreshold = 900;
// Widths where a section can appear or disappear, so the slides have to be recounted.
const rebuildThresholds = [750, resizeThreshold];

// The swiper is only ever rendered on the home page (see layout/theme.liquid), so its container
// is a more reliable signal than the pathname: in the theme editor the preview is served from a
// URL whose path can carry extra segments.
const hasSwiper = () => document.querySelector(".home-swiper") != null;

if (hasSwiper()) {
  document.addEventListener("DOMContentLoaded", function () {
    homeSwiper = buildSwiper();
    if (window.Shopify?.designMode) bindDesignModeEvents();
  });

  let lastWidth = window.innerWidth;
  window.addEventListener("resize", function () {
    const crossedThreshold = rebuildThresholds.some(
      (threshold) =>
        (lastWidth < threshold && window.innerWidth >= threshold) ||
        (lastWidth >= threshold && window.innerWidth < threshold)
    );
    if (crossedThreshold && homeSwiper) rebuildSwiper(homeSwiper.activeIndex);
    lastWidth = window.innerWidth;
  });
}

/**
 * Keep the theme editor in sync with the swiper. Adding, removing or reordering a section changes
 * the slide count, and the editor's own "scroll the section into view" behaviour does nothing
 * inside an `overflow: hidden` container, so selecting a section has to page the swiper instead.
 */
function bindDesignModeEvents() {
  // The editor re-renders a section by replacing its markup, which fires load/unload in quick
  // succession; rebuilding once on the next frame avoids tearing down a swiper we just built.
  let rebuildHandle;
  const scheduleRebuild = (target) => {
    cancelAnimationFrame(rebuildHandle);
    rebuildHandle = requestAnimationFrame(() => rebuildSwiper(slideIndexOf(target)));
  };

  for (const event of ["shopify:section:load", "shopify:section:unload", "shopify:section:reorder"]) {
    document.addEventListener(event, (e) => scheduleRebuild(e.target));
  }

  for (const event of ["shopify:section:select", "shopify:block:select"]) {
    document.addEventListener(event, (e) => {
      const index = slideIndexOf(e.target);
      if (homeSwiper && index != null) homeSwiper.slideTo(index);
    });
  }
}

/**
 * The index of the slide containing `element`, or null when it is not on a slide — a section can
 * be hidden at this width, and a block event's target is nested inside its section.
 */
function slideIndexOf(element) {
  const slide = element?.closest?.(".swiper-slide");
  if (!slide || !homeSwiper) return null;
  const index = homeSwiper.slides.indexOf(slide);
  return index === -1 ? null : index;
}

function rebuildSwiper(targetIndex) {
  if (homeSwiper && !homeSwiper.destroyed) homeSwiper.destroy(true, true);
  homeSwiper = buildSwiper(targetIndex);
  return homeSwiper;
}

function buildSwiper(initialSlide) {
  const mainContent = document.querySelector("#MainContent");
  const sections = mainContent.querySelectorAll(".shopify-section");
  sections.forEach((section) => {
    // A section hidden at this width (e.g. a hero with no media for this screen)
    // must not become an empty slide.
    const isHidden = getComputedStyle(section).display === "none";
    const isMobileOnly =
      window.innerWidth >= resizeThreshold &&
      section.querySelector(".section.mobile-only") != null;

    section.classList.toggle("swiper-slide", !isHidden && !isMobileOnly);
  });

  const homeSwiper = new Swiper(".home-swiper", {
    direction: "vertical",
    slidesPerView: 1,
    initialSlide: initialSlide ?? 0,
    longSwipesRatio: 0.25,
    speed: 500,
    mousewheel: {
      enabled: true,
      sensitivity: 1,
      thresholdDelta: 10,
    },
    effect: "creative",
    creativeEffect: {
      prev: {
        opacity: 1,
        translate: [0, 0, -1],
      },
      next: {
        opacity: 1,
        translate: [0, "100%", 0],
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });

  const header = document.querySelector(".header");

  const syncHeader = (swiper) => {
    const currentSlide = swiper.slides[swiper.activeIndex];
    // Use a data attribute or class to check background type
    if (currentSlide?.classList.contains("header-default")) {
      header.setAttribute("data-sticky-state", "active");
    } else if (currentSlide?.classList.contains("header-inverse")) {
      header.setAttribute("data-sticky-state", "inactive");
    }
  };

  homeSwiper.on("slideChange", syncHeader);
  // A rebuild can land on a slide the header state was never synced for.
  syncHeader(homeSwiper);

  return homeSwiper;
}
